import React from "react";
import { Controller } from "react-hook-form";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { Filter, Download, PlusCircle, Upload } from "lucide-react";
import TransparentButton from "../TransparentButton/TransparentButton";
import "./FilterBar.css";
import "./FilterBarControls.css";
import MultiSelectDropdown from "./MultiSelectDropdown";
import Dropdown from "../Dropdown/Dropdown";
import UserDashboardService from "../../services/UserDashboard.service";

const FilterBar = ({
  control,
  handleSubmit,
  onSubmit,
  onClearFilters,
  filters = [],
  title,
  totalCount,
  isDownload=true,
  isAdd=false,
  onAdd=()=>{},
  tableId = "table-id",
  isDownloadAudio=false,
  hendleDownloadAudio=()=>{},
  isServerExport=false,
  isUpload = false,
  onUpload = () => {}
}) => {
  const [showFilters, setShowFilters] = React.useState(false);
  const [exporting, setExporting] = React.useState(false);

  
 const handleServerExport = handleSubmit(async (formValues) => {
  setExporting(true);
  try {
    const res = await UserDashboardService.exportData(formValues);

    const blob = new Blob([res.data], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Calls_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("CSV export failed", err);
  } finally {
    setExporting(false);
  }
});


  const renderFilterField = (filter) => {
    switch (filter.type) {
      case "select":
        return (
          <Controller
            name={filter.name}
            control={control}
            defaultValue={filter.defaultValue || ""}
            render={({ field }) => (
              <div className="fb-dd">
                <Dropdown
                  name={filter.name}
                  id={filter.name}
                  placeholder={filter.placeholder || "Select"}
                  value={field.value || ""}
                  options={filter.options || []}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    handleSubmit(onSubmit)(); // 👈 auto submit on change
                  }}
                />
              </div>
            )}
          />
        );

      case "multiselect":
        return (
          <Controller
            name={filter.name}
            control={control}
            defaultValue={filter.defaultValue || []}
            render={({ field }) => (
              <div className="fb-ms">
                <MultiSelectDropdown
                  value={field.value || []}
                  onChange={(selectedValues) => {
                    field.onChange(selectedValues || []);
                    handleSubmit(onSubmit)(); // 👈 auto submit on change
                  }}
                  options={filter.options}
                  placeholder={filter.placeholder}
                />
              </div>
            )}
          />
        );

      case "date":
        return (
          <Controller
            name={filter.name}
            control={control}
            defaultValue={filter.defaultValue || ""}
            render={({ field }) => (
              <input
                type="date"
                {...field}
                className="filter-select fb-date"
                onChange={(e) => {
                  field.onChange(e);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
        );

      case "text":
      default:
        return (
          <Controller
            name={filter.name}
            control={control}
            defaultValue={filter.defaultValue || ""}
            render={({ field }) => (
              <input
                type="text"
                {...field}
                className="filter-select fb-input"
                placeholder={filter.placeholder || "Search..."}
                onChange={(e) => {
                  field.onChange(e);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
        );
    }
  };

  return (
    <div className="table-header">
      {/* Left Section */}
      <div className="header-left">
        <h3 className="header-title">
          {title}  {totalCount==0 ?(<></>):(<span className="total-count">{totalCount} Total</span>)}
        </h3>
      </div>

      {/* Right Section */}
      <div className="header-right">
        {showFilters && (
          <div
            className="filters-row filterbar-controls"
            style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}
          >
            {filters.map((filter, idx) => (
              <div className="filter-group" key={idx}>
                {renderFilterField(filter)}
              </div>
            ))}
          </div>
        )}

        {/* Action Buttons */}
        <div className="action-buttons" style={{ display: "flex", gap: "10px" }}>
          {filters.length > 0 &&
            (showFilters ? (

              
              <>
              <button
                className="clear-btn"
                type="button"
                onClick={() => {
                  onClearFilters();
                  setShowFilters(false);
                }}
              >
                Clear Filters
              </button>

              {isUpload && (
                <button
                  type="button"
                  className="export-btn"
                  onClick={onUpload}
                >
                  <Upload size={16} /> Upload
                </button>
              )}
              {isDownloadAudio&& (
                <button
                        className="export-btn"
                        type="button"
                        onClick={() => {
                          hendleDownloadAudio();
                        }}
                      >
                      <Download size={16} /> Download Recordings
                      </button>
                  )}
                  </>

            ) : (
              <button
                className="export-btn"
                type="button"
                onClick={() => setShowFilters(true)}
              >
                <Filter size={16} /> Filters
              </button>
            ))}

          {/* Export Button */}
           
          {isDownload && (
          <ReactHTMLTableToExcel
            className="export-btn"
            table={tableId}
            filename={`${title}_${new Date().toISOString().slice(0, 10)}`}
            sheet="Sheet1"
            buttonText={
              <>
                <Download size={16} /> Export
              </>
            }
          />
          )}
          {isServerExport &&(
          <button
            type="button"
            className="export-btn"
            onClick={handleServerExport}
            disabled={exporting}
          >
            <Download size={16} />
            {exporting ? " Exporting..." : " Export CSV"}
          </button>

          )}
         
        {isAdd && (
          <div title="Add New">
            <PlusCircle size={24} onClick={onAdd} />
          </div>
        )} 
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
